import { Box,Stack,Tab,Tabs } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TabPanelProps } from "../../types/helpers/types";
import { trackEventMatomo } from '../../helpers/matomo';
import FilledForms from "./FilledForms";
import ReportsComponent from "./ReportsComponent";


function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ReportsTabs() {
  const { t } = useTranslation('translation');
  const [value, setValue] = useState<number>(0);
  function handleChange(_event: React.SyntheticEvent, newValue: number) {
    trackEventMatomo('relatórios', 'click', 'aba', newValue === 0 ? 'preenchimentos logados' : 'preenchimentos offline');
    setValue(newValue);
  };

  return (
    <>
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor='secondary'
        textColor='secondary'
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label={t('newReports.logged')} value={0} />
        <Tab label={t('newReports.offline')} value={1} />
      </Tabs>
      <Stack direction='row' width='100%' spacing={5}>
        <CustomTabPanel value={value} index={0}>
          <ReportsComponent />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <FilledForms />
        </CustomTabPanel>
      </Stack>
    </>
  );
}
